import {
  getDepartmentSelectConfig,
  getGradeSelectConfig,
  getPersonSelectConfig,
  getSchoolSelectConfig,
  getToolSelectConfig
} from './selectConfigHelpers.js';

import {updateJobTitle} from './formChangeEventHandlers.js';

export function renderEl($el, options = [], value = null) {
  if (options && options.length) {
    $el[0].selectize.clear(false); // false means trigger onChange event
    $el[0].selectize.clearOptions();
    $el[0].selectize.addOption(options);
    $el[0].selectize.setValue(value);
    $el[0].selectize.enable();
  } else {
    $el.val('');
    $el.trigger('change');
    $el.prop("disabled", false);
  }

  $el.parent().show();
}

export function unRenderEl($el) {
  if ($el[0] && $el[0].selectize) {
    $el[0].selectize.disable();
  } else {
    $el.prop("disabled", true);
  }

  $el.parent().hide();
}

export function initSelect(db) {
  window.$schoolSelect = $('#schoolSelect').selectize(getSchoolSelectConfig());
  window.$personSelect = $('#personSelect').selectize(getPersonSelectConfig());
  window.$toolSelect = $('#toolSelect').selectize(getToolSelectConfig(db));
  window.$departmentSelect = $('#departmentSelect').selectize(getDepartmentSelectConfig());
  window.$gradeSelect = $('#gradeSelect').selectize(getGradeSelectConfig());
  window.$jobTitleInput = $('#jobTitleInput');
  window.$jobTitleInput.change(updateJobTitle);
}
